// V1 Conversion-1｜諮詢頁與 CTA 共用設定（純設定，不含任何商業邏輯）。

/**
 * Readdy 內建 Form（沿用既有「GMB Audit Consultation」表單，不建第二套 lead database）。
 * 送出時必須 POST application/x-www-form-urlencoded 到此位址。
 */
export const CONSULT_FORM_SUBMIT_ADDR = 'https://readdy.ai/api/form/db1rdm1ggrtvtk1bgv40';

/**
 * 天地人網 LINE 官方帳號連結（V1 Conversion-1.1 正式啟用）。
 * 此為公開聯絡網址，不是 Secret；全站 GMB Audit 範圍的 LINE CTA 一律集中使用此常數，
 * 避免不同 Component 各自 hardcode 出現不同網址。
 */
export const LINE_OFFICIAL_URL = 'https://lin.ee/zQPjHPY';

/** LINE CTA 文案（正式）。 */
export const LINE_CTA_LABEL = '加入 LINE 詢問';